<script lang="ts" context="module">
  import debounce from "lodash.debounce";
  import { onMount } from "svelte";
</script>

<script lang="ts">
  export let isValid: boolean = false;
  export let value: string = "";
  export let placeholder: string | undefined | null = undefined;
  export let autocomplete: string | undefined | null = undefined;
  export let userLeftInput: boolean = false;
  export let inputFieldIsFocused: boolean = false;
  export let readOnly: boolean | undefined | null = undefined;
  export let tabIndex: number | undefined | null = undefined;
  export let autoFocus: boolean = false;
  export let type: "password" | "text" = "text";

  let inputElement: HTMLInputElement;
  let showPassword: boolean = false;

  onMount(() => {
    inputElement.type = type;
    if (autoFocus) {
      inputElement.focus();
    }
  });

  function toggleShowPassword() {
    showPassword = !showPassword;
    inputBlur.cancel();
    inputFieldIsFocused = true;
    if (showPassword) {
      inputElement.type = "text";
    } else {
      inputElement.type = "password";
    }
    inputElement.focus();
  }

  const inputBlur = debounce(() => {
    inputFieldIsFocused = false;
    userLeftInput = true;
  }, 30);

  function inputFocus() {
    inputBlur.cancel();
    inputFieldIsFocused = true;
    userLeftInput = false;
  }
</script>

<div class="relative w-full">
  <input
    class="focusable w-full rounded border px-3 py-2 text-14 outline outline-2"
    class:pr-10={type === "password"}
    class:bg-nxgray-50={readOnly}
    class:text-nxgray-300={readOnly}
    class:pointer-events-none={readOnly}
    class:text-nxgray-600={!readOnly}
    class:valid={!readOnly && isValid}
    class:custom={!readOnly && (inputFieldIsFocused || !value.length)}
    class:outline-transparent={!value.length || readOnly || !inputFieldIsFocused}
    class:outline-danger-200={!readOnly && !isValid && inputFieldIsFocused}
    class:outline-success-300={!readOnly && isValid && inputFieldIsFocused}
    class:border-gray-300={!readOnly && !inputFieldIsFocused}
    class:border-nxgray-500={!readOnly && inputFieldIsFocused && !value.length}
    class:!border-danger-500={!readOnly && !isValid && inputFieldIsFocused && value.length}
    class:!border-success-700={!readOnly && isValid && inputFieldIsFocused}
    bind:this={inputElement}
    on:blur={inputBlur}
    on:focus={inputFocus}
    bind:value
    on:input
    {autocomplete}
    {placeholder}
    readonly={readOnly}
    tabindex={tabIndex} />
  {#if type === "password"}
    <div class="absolute bottom-0 right-0 top-0 flex items-center justify-center px-2">
      <button
        class="clickable material-icons focusable !text-18 text-nxgray-400"
        on:click|stopPropagation|preventDefault={toggleShowPassword}
        on:blur={inputBlur}
        on:focus={inputFocus}>
        {#if showPassword}
          visibility_off
        {:else}
          visibility
        {/if}
      </button>
    </div>
  {/if}
</div>

<style>
  input:not(.custom):focus,
  input:not(.custom):not([readonly]).valid:focus {
    border-color: theme("borderColor.nxgray.600");
  }
</style>
